module.exports = __webpack_public_path__ + "img/student-tracking-250.4f1e30a5.png";